import { useContext, useEffect, useState } from 'react';
import { Modal } from 'antd';
import { birthdayQuotes } from './birthdayQuotes';
import { AppContext } from '../../context/App/AppContext';
import Icon from '../UI/Icon/Icon';
import { getBirthdayDisplayKey, isBirthdayToday } from './birthdayUtils';

const BirthdayWishesModal = () => {
  const {
    userData: { _id, dateofbirth }
  } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const randomQuoteIndex = Math.floor(Math.random() * birthdayQuotes.length);
  const birthdayDisplayKey = getBirthdayDisplayKey(_id);

  useEffect(() => {
    if (isBirthdayToday(dateofbirth) && localStorage.getItem(birthdayDisplayKey) === null) {
      setShowModal(true);
    }
  }, [birthdayDisplayKey, dateofbirth]);

  const onClose = () => {
    localStorage.setItem(birthdayDisplayKey, 'true');
    setShowModal(false);
  };

  return (
    <>
      <Modal open={showModal} onCancel={onClose}>
        <div className="text-center text-xl font-bold">
          <Icon name={'birthday'} className={'mx-auto'} size={50} />
          <div>{birthdayQuotes[randomQuoteIndex]}</div>
          <div className={'text-2xl mt-4'}>Happy birthday!</div>
        </div>
      </Modal>
    </>
  );
};

export default BirthdayWishesModal;
